import React, { useState, useEffect } from 'react';
import { Button, Card, notification, Modal } from 'antd';
import { MainContainer } from './ProductCategory.styles';
import TableComponent from './table/Table';
import ProductCategoryModal from './ProductCategoryModal/ProductCategoryModal';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { postProductCategory, getAllProductCategory, deleteProductCategory, updateProductCategory } from 'utils/apis/configProductCategory';

const ProductCategory = () => {
  const [isVisible, setVisible] = useState(false);
  const [isWarningVisible, setWarningVisible] = useState(false);

  const [productCategoryData, setProductCategoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedProductCategory, setSelectedProductCategory] = useState('');
  const [linkedProductsWarning, setLinkedProductsWarning] = useState([]);

  useEffect(() => {
    //not sure why after closing the warningModal, the visible is automatically set to hidden ?? temp workaround i guess.
    if (isWarningVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
    fetchData();
  }, [isWarningVisible]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await getAllProductCategory();
      setProductCategoryData(response.data);
    } catch (error) {
      console.error('Error fetching Product Category data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectedProductCategory = productCategory => {
    setSelectedProductCategory(productCategory);
    setVisible(true);
  };
  const showModal = () => {
    setVisible(true);
  };
  const closeModal = () => {
    setVisible(false);
  };

  const closeWarningModal = () => {
    setWarningVisible(false);
    setLinkedProductsWarning(''); // Optionally, reset any other state related to the Modal
    document.body.style.overflow = 'visible';
  };

  const handleSubmit = async (values, selectedProductCategoryId) => {
    try {
      if (selectedProductCategoryId === 'new') {
        await postProductCategory(values);
        notification.success({
          message: 'Success',
          description: 'Product Category has been created successfully.'
        });
      } else {
        await updateProductCategory(selectedProductCategoryId, values);
        notification.success({
          message: 'Success',
          description: 'Product Category has been updated successfully.'
        });
      }
      fetchData();
    } catch (error) {
      console.error('Error submitting Product Category:', error);
    }
  };

  const handleDelete = async selectedProductCategoryId => {
    try {
      const productCategory = productCategoryData.filter(product => product._id === selectedProductCategoryId);
      //console.log(productCategory[0].linkedProducts.length);

      if (productCategory[0].linkedProducts.length) {
        const linkedProductNames = productCategory[0].linkedProducts.map(product => product.name);
        setLinkedProductsWarning(linkedProductNames);
        setWarningVisible(true);
        return;
      }

      const deleted = await deleteProductCategory(selectedProductCategoryId);
      notification.success({
        message: 'Deleted',
        description: 'Product Category has been deleted successfully.'
      });
      //console.log('Product Category deleted successfully:', deleted);
      fetchData();
    } catch (error) {
      console.error('Error deleting Product Category:', error);
      notification.success({
        message: 'Deleted',
        description: `Encoutered Problem ${error}`
      });
    }
  };

  console.log(linkedProductsWarning);

  return (
    <>
      <MainContainer>
        <Button onClick={showModal} style={{ marginBottom: '40px' }} type="primary">
          Create Product Category
        </Button>
        <Card>
          <TableComponent data={productCategoryData} loading={isLoading} onSelectedProductCategory={handleSelectedProductCategory} />
        </Card>
        <ProductCategoryModal
          data={productCategoryData}
          offVisible={closeModal}
          visibility={isVisible}
          onSubmit={handleSubmit}
          fetchData={fetchData}
          selectedProductCategory={selectedProductCategory}
          resetProductCategory={() => setSelectedProductCategory('')}
          onDelete={handleDelete}
        />
      </MainContainer>
      {linkedProductsWarning && (
        <Modal
          title={
            <span>
              <ExclamationCircleOutlined style={{ color: 'red', marginRight: '8px' }} />
              Cannot Delete
            </span>
          }
          visible={isWarningVisible}
          onCancel={closeWarningModal}
          footer={null}
        >
          <p>This category is linked to the following product(s), please remove them before deleting:</p>
          <ul>
            {linkedProductsWarning.map((productName, index) => (
              <li key={index}>{productName}</li>
            ))}
          </ul>
        </Modal>
      )}
    </>
  );
};

export default ProductCategory;
